import { memo, type CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { translatePriority } from '@/utils/enumTranslation';
import { PRIORITY_COLORS, Priority } from '@/types';

import styles from './PriorityBadge.module.css';

interface PriorityBadgeProps {
  readonly priority: Priority;
  readonly variant?: 'inline' | 'compact';
}

export const PriorityBadge = memo(function PriorityBadge({
  priority,
  variant = 'inline',
}: PriorityBadgeProps) {
  const { t } = useTranslation();

  const color = PRIORITY_COLORS[priority];
  const isCompact = variant === 'compact';

  return (
    <span
      className={styles.badge}
      style={{ '--priority-color': color } as CSSProperties}
    >
      <span className={styles.dot} />
      {!isCompact && (
        <span className={styles.text}>{translatePriority(priority, t)}</span>
      )}
    </span>
  );
});
